// extracted by mini-css-extract-plugin
export default {"textFilter":"textFilter_textFilter__sU0EB","unpadded":"textFilter_unpadded__ToqRw"};